import { JobType, JobStatus } from '@pt/enums/jobs'
import { t } from '@/lang'

export const JobStatusOption = [
  {
    label: t('playTurbo.taskCenter.jobStatus.pending').toString(),
    value: JobStatus.Pending,
  },
  {
    label: t('playTurbo.taskCenter.jobStatus.running').toString(),
    value: JobStatus.Running,
  },
  {
    label: t('playTurbo.taskCenter.jobStatus.success').toString(),
    value: JobStatus.Success,
  },
  {
    label: t('playTurbo.taskCenter.jobStatus.failed').toString(),
    value: JobStatus.Failed,
  },
  {
    label: t('playTurbo.taskCenter.jobStatus.partSuccess').toString(),
    value: JobStatus.PartSuccess,
  },
  {
    label: t('playTurbo.taskCenter.jobStatus.stopped').toString(),
    value: JobStatus.Stopped,
  },
]

export const DemandOrderOption = [
  {
    label: t('playTurbo.order.status.completed').toString(),
    value: JobStatus.Success,
  },
  {
    label: t('playTurbo.order.status.rejected.action').toString(),
    value: JobStatus.Failed,
  },
]

export const JobTypeOption = [
  {
    label: t('playTurbo.taskCenter.jobType.vrecRecording').toString(),
    value: JobType.VrecRecording,
  },
  {
    label: t('playTurbo.taskCenter.jobType.veRender').toString(),
    value: JobType.VeRender,
  },
  {
    label: t('playTurbo.taskCenter.jobType.VeSimple').toString(),
    value: JobType.VeSimple,
  },
  {
    label: t('playTurbo.taskCenter.jobType.aigcTask').toString(),
    value: JobType.AigcTask,
  },
  {
    label: t('playTurbo.taskCenter.jobType.gmDown').toString(),
    value: JobType.GmDown,
  },
  {
    label: t('playTurbo.taskCenter.jobType.dmDown').toString(),
    value: JobType.DmDown,
  },
  {
    label: t('playTurbo.taskCenter.jobType.gmPush').toString(),
    value: JobType.GmPush,
  },
  {
    label: t('playTurbo.taskCenter.jobType.dmPush').toString(),
    value: JobType.DmPush,
  },
  {
    label: t('playTurbo.taskCenter.jobType.aiRemove').toString(),
    value: JobType.VeElimination,
  },
  {
    label: t('playTurbo.order.3dmodel.handle').toString(),
    value: JobType.DemandOrder,
  },
  {
    label: t('playTurbo.order.3dmodel.handle').toString(),
    value: JobType.DemandOrder,
  },
  {
    label: t('playTurbo.taskCenter.jobType.subtitles').toString(),
    value: JobType.VeOcr,
  },
  {
    label: t('playTurbo.taskCenter.jobType.aiBanner').toString(),
    value: JobType.AiBanner,
  },
]
